export default "__VITE_ASSET__CwMLKrju__"